import React from 'react';
import { TProjects } from 'store/companies/companiesTypes';
import styled from 'styled-components';
import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { RouteComponentProps } from '@reach/router';
import moment from 'moment-jalaali';
import { parse } from 'query-string';
import SanitizedHTML from 'react-sanitized-html';
import { blue, border1 } from 'utils/style/colors';
import { isANumber, convertDigitToProperFormat } from 'utils/number';
import { StringOrNull, ISearchParams } from 'store/entity/types';
import { ITasks, IUsers, RootState } from 'store/store';
import { LoadingParent } from './styles';
import messages from './Messages';
import { display } from 'components/ErrorView/ErrorDialog';
import BubbleLoading from 'components/BubbleLoading/BubbleLoading';
import protectedRoute from 'components/protectedRoute';
import { ReportTitle } from 'components/Report/PrintTaskReport/styles';
import { roundToDynamicFloating } from 'components/Chart/analyseUtils';
import { appDispatch } from 'store/store';
import { IThisUserState } from 'store/thisUser/thisUserSlice';
import {
  getCompanyFn,
  getCompanyHandler,
} from 'store/companies/companiesSlice';
import {
  requireSeveralUser,
  requireSeveralUserFn,
  requireUser,
  requireUserFn,
} from 'store/users/usersSlice';
import {
  getTask,
  getTaskFn,
  searchTasks,
  searchTasksFn,
} from 'store/tasks/tasksSlice';
import { IUser } from 'store/users/usersType';
import { IAssignmentView, ITask } from 'store/tasks/tasksType';
import Input from '../../../components/Input';

moment.locale('fa');
moment.loadPersian({ usePersianDigits: true, dialect: 'persian-modern' });

type StateToProps = {
  thisUser: IThisUserState;
  tasks: ITasks;
  projects: TProjects;
  parsed: any;
  user: IUsers['map'];
};
type DispatchToProps = {
  getCompany: (companyId: number) => ReturnType<typeof getCompanyFn>;
  getTask: (taskId: number) => ReturnType<typeof getTaskFn>;
  requireUser: (userId: number) => ReturnType<typeof requireUserFn>;
  requireSeveralUser: (
    userId: number[]
  ) => ReturnType<typeof requireSeveralUserFn>;
  searchTasks: (params: ISearchParams) => ReturnType<typeof searchTasksFn>;
};
type ParamProps = {
  companyId: string;
};
type OwnProps = RouteComponentProps<ParamProps>;
type ComponentProps = OwnProps & StateToProps & DispatchToProps;
type ComponentState = {
  loading: boolean;
  users: { [key: number]: IUser };
  showCreator: boolean;
};
const PAGE_SIZE = 50;
const PrintInfo = styled('div')`
  width: 100%;
  background: ${blue};
  color: var(--exact-white);
  padding: 5px 0;
  text-align: center;
  @media print {
    display: none;
  }
`;

const ReportContent = styled('div')`
  // width: 900px;
  margin: 3em;
`;

export const Table = styled('table')`
  margin: 1rem 0;
  border-collapse: collapse;
  & th {
    background-color: #666;
    color: var(--exact-white);
  }
  & td,
  th {
    text-align: center;
    border: ${border1};
    // max-width: 200px;
  }
  & tr:nth-child(even) {
    background-color: #f2f2f2;
  }
`;

const AverageRow = styled('tr')`
  background-color: #666 !important;
  color: var(--exact-white);
`;

const PrintDate = styled('div')`
  text-align: center;
  margin: 1rem 0;
`;

class PrintTasks extends React.PureComponent<ComponentProps, ComponentState> {
  readonly state: ComponentState = {
    loading: true,
    users: {},
    showCreator: false,
  };

  componentDidMount() {
    const companyId = Number(this.props.companyId);
    this.props
      .getCompany(companyId)
      .then(() => this.handleRequireTasks())
      .then(() => {
        const promises: any = [];
        if (this.props.parsed.parentId) {
          promises.push(this.props.getTask(Number(this.props.parsed.parentId)));
        }
        if (this.props.parsed.assigneeId) {
          promises.push(
            this.props.requireUser(Number(this.props.parsed.assigneeId))
          );
        }
        Promise.all(promises).then(() => {
          this.setState({ loading: false });
          setTimeout(window.print, 2000);
        });
      })
      .catch((err: any) => {
        display(err);
      });
  }

  handleRequireTasks = async () => {
    const {
      projectId,
      archived,
      order,
      whichTasks,
      basedOnTemplate,
      taskStatus,
      parentId,
      fromDate,
      toDate,
      mainProgressFrom,
      mainProgressTo,
      secondaryProgressFrom,
      secondaryProgressTo,
      verifyStatus,
      itemId,
      status,
      assigneeId,
      fieldValues,
      includeDrafted,
    } = this.props.parsed;
    let fieldValuesObj: any = undefined;
    if (fieldValues) {
      fieldValuesObj = JSON.parse(fieldValues);
    }
    const params: ISearchParams = {
      companyId: Number(this.props.companyId),
      projectId:
        projectId !== 'null' && projectId !== 'undefined'
          ? projectId
          : undefined,
      parentId,
      order: order ? order : 'dueDate',
      from: 0,
      count: PAGE_SIZE,
      fromDate,
      toDate,
      itemId,
      status,
      assigneeId,
      includeDrafted,
    };
    if (fieldValuesObj && Object.keys(fieldValuesObj).length > 0) {
      params.fieldValues = fieldValuesObj;
    }
    if (archived !== 'true') {
      params.archived = false;
    }
    if (whichTasks === 'assignedToMe') {
      params.assigneeId = Number(this.props.thisUser.userId);
    } else if (whichTasks === 'createdByMe') {
      params.creatorIds = Number(this.props.thisUser.userId);
    }
    if (basedOnTemplate === 'categorized') {
      params.parentId = null;
    } else if (basedOnTemplate !== 'all') {
      params.templateId = basedOnTemplate;
    }
    if (taskStatus !== 'all') {
      params.status = taskStatus;
    }
    params.verifyStatus = verifyStatus;
    params.mainProgressFrom = mainProgressFrom;
    params.mainProgressTo = mainProgressTo;
    params.secondaryProgressFrom = secondaryProgressFrom;
    params.secondaryProgressTo = secondaryProgressTo;
    const tasks: ITask[] = await this.getTasksToTheEnd(params, []);
    const userIds = tasks.reduce((users: Set<number>, task: ITask) => {
      Object.values(task.assignee).forEach((assignee) => {
        users.add(assignee.userId);
      });
      Object.values(task.verifiers || {}).forEach((verifier) => {
        users.add(verifier.userId);
      });
      return users;
    }, new Set<number>());
    if (userIds.size)
      await this.props
        .requireSeveralUser(Array.from(userIds))
        .then(({ users }: { users: IUser[] }) => {
          this.setState({
            users: users
              ? users.reduce((current: any, item: IUser) => {
                  current[item.id] = item;
                  return current;
                }, {})
              : [],
          });
        });
    return Promise.resolve();
  };

  getTasksToTheEnd = (
    params: ISearchParams,
    current: ITask[]
  ): Promise<ITask[]> => {
    return this.props.searchTasks(params).then(({ tasks }) => {
      if (
        tasks.length > 0 &&
        tasks.length === PAGE_SIZE &&
        typeof params.from === 'number'
      ) {
        params.from = params.from + PAGE_SIZE;
        return this.getTasksToTheEnd(params, [...current, ...tasks]);
      }
      return Promise.resolve([...current, ...tasks]);
    });
  };

  render() {
    const { tasks, projects } = this.props;
    const {
      projectId,
      archived,
      order,
      whichTasks,
      basedOnTemplate,
      taskStatus,
      parentId,
      fromDate,
      toDate,
      mainProgressFrom,
      mainProgressTo,
      secondaryProgressFrom,
      verifyStatus,
      status,
      assigneeId,
      includeDrafted,
    } = this.props.parsed;
    const userId = Number(this.props.thisUser.userId);

    const safeArchived = archived === 'true';
    const safeProjectId =
      !projectId || projectId === 'null' || projectId === 'undefined'
        ? null
        : Number(projectId);
    const assigneeIdNumber = Number(assigneeId);

    let filteredTasks = Object.values(tasks.data).filter(
      (task) => !task.template
    );
    filteredTasks = filteredTasks.filter(
      (task) => includeDrafted || task.draft === false
    );
    if (!parentId) {
      // filter tasks based on archived
      filteredTasks = filteredTasks.filter(
        (task) => (safeArchived && task.archived) || !task.archived
      );
      // filter tasks based on their project
      if (safeProjectId) {
        filteredTasks = filteredTasks.filter(
          (task: ITask) => task.projectId === safeProjectId
        );
      }
      // filter tasks based on their creator
      if (whichTasks === 'createdByMe') {
        filteredTasks = filteredTasks.filter(
          (task: ITask) => task.creator === userId
        );
      }
      // filter tasks based on their assignment and verifier
      if (whichTasks === 'assignedToMe') {
        filteredTasks = filteredTasks.filter(
          (task: ITask) =>
            Object.keys(task.assignee).includes(userId.toString()) ||
            (task.verifiers && task.verifiers[userId]) ||
            task.taskPublisher!.userId === userId ||
            task.subTaskPublisher!.userId === userId
        );
      }

      // filter tasks based on their template
      if (basedOnTemplate === 'categorized') {
        filteredTasks = filteredTasks.filter(
          (task: ITask) => !isANumber(task.parentId)
        );
      } else if (basedOnTemplate !== 'all') {
        filteredTasks = filteredTasks.filter(
          (task: ITask) => task.templateId === Number(basedOnTemplate)
        );
      }
      // filter tasks based on their status
      if (taskStatus !== 'all' && whichTasks === 'assignedToMe') {
        filteredTasks = filteredTasks.filter((task: ITask) => {
          if (taskStatus === 'incomplete') {
            return task.assignee[userId].status !== 'complete';
          }
          return task.assignee[userId].status === taskStatus;
        });
      }
    } else {
      filteredTasks = filteredTasks.filter(
        (task: ITask) => task.parentId === Number(parentId)
      );
    }

    // filter tasks based on task status and reportParams for task report
    if (Number(mainProgressFrom) === 100) {
      filteredTasks = filteredTasks.filter(
        (task: ITask) => task.mainProgress === 100
      );
    } else if (Number(mainProgressFrom) === 0.01) {
      filteredTasks = filteredTasks.filter(
        (task) => task.mainProgress! > 0 && task.mainProgress! < 100
      );
    } else if (
      Number(mainProgressFrom) === 0 &&
      Number(mainProgressTo) === 99.99
    ) {
      filteredTasks = filteredTasks.filter(
        (task: ITask) => task.mainProgress! >= 0 && task.mainProgress! < 100
      );
    } else if (Number(mainProgressFrom) === 0) {
      filteredTasks = filteredTasks.filter(
        (task: ITask) => task.mainProgress === 0
      );
    } else if (Number(secondaryProgressFrom) === 100) {
      filteredTasks = filteredTasks.filter(
        (task: ITask) => task.secondaryProgress === 100
      );
    } else if (Number(secondaryProgressFrom) === 0.01) {
      filteredTasks = filteredTasks.filter(
        (task) => task.secondaryProgress! > 0 && task.secondaryProgress! < 100
      );
    } else if (Number(secondaryProgressFrom) === 0) {
      filteredTasks = filteredTasks.filter(
        (task: ITask) => task.secondaryProgress === 0
      );
    } else if (verifyStatus === 'complete') {
      filteredTasks = filteredTasks.filter((task: ITask) =>
        Object.values(task.verifiers || {}).some(
          (verifier) => verifier.status === 'complete'
        )
      );
    } else if (verifyStatus === 'notStarted') {
      filteredTasks = filteredTasks.filter((task: ITask) =>
        Object.values(task.verifiers || {}).some(
          (verifier) => verifier.status === 'notStarted'
        )
      );
    } else if (verifyStatus === 'rejected') {
      filteredTasks = filteredTasks.filter((task: ITask) =>
        Object.values(task.verifiers || {}).some(
          (verifier) => verifier.status === 'rejected'
        )
      );
    } else if (status) {
      filteredTasks = filteredTasks.filter((task: ITask) => {
        return Object.values(task.assignee).find(
          (assignee) =>
            assignee.userId === assigneeIdNumber && assignee.status === status
        );
      });
    }
    // sort tasks
    filteredTasks = filteredTasks.sort((a: ITask, b: ITask) => {
      const safeOrder = order ? order : 'dueDate';
      let aDate = a[safeOrder];
      let bDate = b[safeOrder];
      if (aDate === undefined) {
        aDate = 77777777777000;
      }
      if (bDate === undefined) {
        bDate = 77777777777000;
      }
      if (aDate === bDate) {
        return a.id - b.id;
      }
      return aDate - bDate;
    });
    const printableFieldOfTemplates = {};
    const bucketedTasks = filteredTasks.reduce((buckets: any, task: ITask) => {
      if (buckets[task.templateId]) {
        buckets[task.templateId].push(task);
      } else {
        buckets[task.templateId] = [task];
      }

      task.fields?.forEach((field: any) => {
        if (field.showInPrint) {
          if (!printableFieldOfTemplates[task.templateId])
            printableFieldOfTemplates[task.templateId] = {};
          printableFieldOfTemplates[task.templateId][field.name] =
            field.title || field.name;
        }
      });
      return buckets;
    }, {});

    return (
      <div>
        <PrintInfo>
          <span>{messages.printWillStartAutomatically}</span>
          <Input
            id="showcreator"
            type="checkbox"
            checked={this.state.showCreator}
            labelStyle={{ color: 'black' }}
            label={messages.showCreator}
            onChange={(e: any) => {
              this.setState({ showCreator: e.target.checked });
            }}
          />
        </PrintInfo>
        <ReportContent>
          {this.state.loading ? (
            <LoadingParent>
              <BubbleLoading />
            </LoadingParent>
          ) : (
            <React.Fragment>
              <div>
                {safeProjectId ||
                basedOnTemplate !== 'all' ||
                (fromDate && toDate) ? (
                  <ReportTitle>
                    <span>
                      {safeProjectId && projects[safeProjectId].name}
                      {basedOnTemplate !== 'all' && (
                        <span>
                          {safeProjectId && ' - '}
                          {tasks.data[Number(basedOnTemplate)]?.taskName || ''}
                        </span>
                      )}
                    </span>
                    {!!assigneeIdNumber && (
                      <span>
                        {messages.userTasks(
                          this.props.user[assigneeIdNumber]?.name || ''
                        )}
                      </span>
                    )}
                    {fromDate && toDate && (
                      <span>
                        {messages.fromToDate(
                          convertDigitToProperFormat(
                            moment(Number(fromDate)).format('jD jMMMM jYYYY')
                          ),
                          convertDigitToProperFormat(
                            moment(Number(toDate)).format('jD jMMMM jYYYY')
                          )
                        )}
                      </span>
                    )}
                  </ReportTitle>
                ) : null}
                {parentId && (
                  <SanitizedHTML
                    html={tasks.data[Number(parentId)].title}
                  ></SanitizedHTML>
                )}
              </div>
              {Object.keys(bucketedTasks).map((templateId) => {
                const templateOptions =
                  tasks.data[Number(templateId)].templateReportOptions;
                const parentTemplateId =
                  tasks.data[Number(parentId)]?.templateId;
                const parentTemplateOptions =
                  tasks.data[Number(parentTemplateId)]?.templateReportOptions;
                let totalMainMessage: StringOrNull = null;
                let totalSecondaryMessage: StringOrNull = null;

                let mainProgressAvg = 0;
                let secondaryProgressAvg = 0;
                if (parentId) {
                  mainProgressAvg = tasks.data[Number(parentId)].mainProgress!;
                  totalMainMessage = parentTemplateOptions!.mainProgressTitle!;
                  secondaryProgressAvg =
                    tasks.data[Number(parentId)].secondaryProgress!;
                  totalSecondaryMessage =
                    parentTemplateOptions!.secondaryProgressTitle!;
                } else {
                  let sumOfMainProgress = 0;
                  let countOfMainProgress = 0;
                  let sumOfSecondaryProgress = 0;
                  let countOfSecondaryProgress = 0;
                  bucketedTasks[templateId].forEach((task: ITask) => {
                    if (typeof task.mainProgress === 'number') {
                      countOfMainProgress += 1;
                      sumOfMainProgress += task.mainProgress;
                    }
                    if (typeof task.secondaryProgress === 'number') {
                      countOfSecondaryProgress += 1;
                      sumOfSecondaryProgress += task.secondaryProgress;
                    }
                  });
                  mainProgressAvg = sumOfMainProgress / countOfMainProgress;
                  secondaryProgressAvg =
                    sumOfSecondaryProgress / countOfSecondaryProgress;
                  totalMainMessage =
                    templateOptions && !!templateOptions.mainProgressTitle
                      ? messages.averageOfProgress(
                          templateOptions.mainProgressTitle
                        )
                      : null;
                  totalSecondaryMessage =
                    templateOptions && !!templateOptions.secondaryProgressTitle
                      ? messages.averageOfProgress(
                          templateOptions.secondaryProgressTitle
                        )
                      : null;
                }
                const hasAssignee = bucketedTasks[templateId][0].haveAssignee;
                const hasVerifier = bucketedTasks[templateId][0].haveVerifier;

                return (
                  <Table key={templateId}>
                    <thead>
                      <tr>
                        <th>{messages.rowNumber}</th>
                        {this.state.showCreator && <th>{messages.creator}</th>}
                        <th>{messages.title}</th>
                        {hasAssignee && (
                          <th>
                            {messages.assignee(
                              bucketedTasks[templateId]
                                ? bucketedTasks[templateId][0].assigneeTitle
                                : undefined
                            )}
                          </th>
                        )}
                        {hasVerifier && (
                          <th>
                            {messages.verifier(
                              bucketedTasks[templateId]
                                ? bucketedTasks[templateId][0].verifierTitle
                                : undefined
                            )}
                          </th>
                        )}
                        <th>{messages.dueDate}</th>
                        {templateOptions &&
                          templateOptions.mainProgressTitle && (
                            <th>{templateOptions.mainProgressTitle}</th>
                          )}
                        {templateOptions &&
                          templateOptions.secondaryProgressTitle && (
                            <th>{templateOptions.secondaryProgressTitle}</th>
                          )}
                        {status && <th>{messages.status}</th>}
                        {!safeProjectId && <th>{messages.projectName}</th>}
                        {Object.entries(
                          printableFieldOfTemplates[templateId] || {}
                        ).map(([name, title]) => {
                          return <th key={name}>{title as string}</th>;
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {bucketedTasks[templateId].map(
                        (task: ITask, index: number) => {
                          let dueDate;
                          if (task.dueDate) {
                            dueDate = convertDigitToProperFormat(
                              moment(task.dueDate).format('jYYYY/jMM/jDD')
                            );
                          }
                          let userAssignee: IAssignmentView;
                          if (status) {
                            userAssignee = task.assignee[assigneeIdNumber];
                          }

                          const assigneeStr = Object.values(
                            task.assignee
                          ).reduce((current: string, value: any) => {
                            const user = this.state.users[Number(value.userId)];
                            return (
                              current +
                              (current ? '، ' : '') +
                              (user
                                ? user.name
                                : messages.removedUser(Number(value.userId)))
                            );
                          }, '');

                          const verifierIds = Object.values(
                            task.verifiers || {}
                          ).map((v) => v.userId);
                          const verifierStr =
                            verifierIds.length > 0
                              ? verifierIds
                                  .map(
                                    (id) => this.state.users[Number(id)]?.name
                                  )
                                  .filter(Boolean)
                                  .join('، ')
                              : '';
                          return (
                            <tr key={task.id}>
                              <td>{convertDigitToProperFormat(index + 1)}</td>
                              {this.state.showCreator && (
                                <td>
                                  {this.state.users[Number(task.creator)]?.name}
                                </td>
                              )}
                              <td>
                                <SanitizedHTML
                                  html={
                                    /*
                                    task.taskName +
                                    ' ' +*/
                                    task.title
                                  }
                                ></SanitizedHTML>
                              </td>
                              {hasAssignee && <td>{assigneeStr}</td>}
                              {hasVerifier && <td>{verifierStr}</td>}
                              <td>{dueDate}</td>
                              {templateOptions &&
                                templateOptions.mainProgressTitle && (
                                  <td>
                                    {convertDigitToProperFormat(
                                      roundToDynamicFloating(
                                        task.mainProgress || 0
                                      )
                                    )}
                                  </td>
                                )}
                              {templateOptions &&
                                templateOptions.secondaryProgressTitle && (
                                  <td>
                                    {convertDigitToProperFormat(
                                      roundToDynamicFloating(
                                        task.secondaryProgress || 0
                                      )
                                    )}
                                  </td>
                                )}
                              {status && (
                                <td>
                                  {messages.assigneeStatus(
                                    userAssignee!.status
                                  )}
                                  <span style={{ display: 'block' }}>
                                    {task.type === 'progressive' &&
                                      messages.progress(
                                        convertDigitToProperFormat(
                                          userAssignee!.progress
                                        )
                                      )}
                                  </span>
                                </td>
                              )}
                              {!safeProjectId && (
                                <td>{projects[task.projectId].name}</td>
                              )}
                              {Object.entries(
                                printableFieldOfTemplates[templateId] || {}
                              ).map(([name, _]) => {
                                const field = task.fields.find(
                                  (f: any) => f.name === name
                                );
                                return (
                                  <td key={name}>
                                    {field?.type === 'html' ? (
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: field?.value || '',
                                        }}
                                      />
                                    ) : (
                                      field?.value
                                    )}
                                  </td>
                                );
                              })}
                            </tr>
                          );
                        }
                      )}
                      {totalMainMessage && (
                        <AverageRow>
                          <td colSpan={100}>
                            {totalMainMessage}
                            {' : '}
                            {convertDigitToProperFormat(
                              roundToDynamicFloating(mainProgressAvg || 0)
                            )}
                          </td>
                        </AverageRow>
                      )}
                      {totalSecondaryMessage && (
                        <AverageRow>
                          <td colSpan={100}>
                            {totalSecondaryMessage}
                            {' : '}
                            {convertDigitToProperFormat(
                              roundToDynamicFloating(secondaryProgressAvg || 0)
                            )}
                          </td>
                        </AverageRow>
                      )}
                    </tbody>
                  </Table>
                );
              })}
            </React.Fragment>
          )}
          <PrintDate>
            {`${messages.dateOfPrint}:
            ${convertDigitToProperFormat(moment().format('jD jMMMM jYYYY - HH:MM'))}`}
          </PrintDate>
        </ReportContent>
      </div>
    );
  }
}

const mapStateToProps: MapStateToProps<StateToProps, OwnProps, RootState> = (
  state,
  props
) => {
  const thisUser = state.thisUser;
  const tasks = state.tasks;
  const projects: TProjects = {};
  Object.values(state.companies.data).forEach((cmp) => {
    Object.assign(projects, cmp.projects);
  });
  let parsed;
  if (props.location) {
    parsed = parse(props.location.search);
  }
  const user = state.users.map;

  return { thisUser, tasks, projects, parsed, user };
};

const mapDispatchToProps: MapDispatchToProps<
  DispatchToProps,
  OwnProps
> = () => ({
  getCompany: (companyId: number) =>
    appDispatch(getCompanyHandler({ companyId })),
  getTask: (taskId: number) => appDispatch(getTask({ taskId })),
  requireUser: (userId: number) => appDispatch(requireUser({ userId })),
  requireSeveralUser: (userIds: number[]) =>
    appDispatch(requireSeveralUser({ usersList: userIds })),
  searchTasks: (params: ISearchParams) => appDispatch(searchTasks({ params })),
});

export default protectedRoute(
  connect(mapStateToProps, mapDispatchToProps)(PrintTasks)
);
